import { Banner } from '@tackle-io/platform-ui';
import FormSectionCard from '../components/FormSectionCard';
import { FormSectionConfig } from '../constants';
import { AssignmentIcon } from 'packages/cosell/assets';
import { FieldEnum } from './sectionSchema';
import Subsection from '../components/Subsection';
import SolutionAreasFields from './SolutionAreaFields';
import {
  SectionTextField,
  SectionNumberField,
  SectionDateField,
  SectionTextAreaField,
  SectionRadioGroupField,
} from './SectionFields';
import SelectPartnerLocation from './SelectPartnerLocation';
import { useParams } from 'react-router';

const DealDetailsFormSection = () => {
  const params = useParams<{ crmId?: string }>();

  return (
    <FormSectionCard
      title={FormSectionConfig.dealDetails.title}
      subtitle={null}
      icon={<AssignmentIcon />}
      data-id={FormSectionConfig.dealDetails.dataId}
      sectionId={FormSectionConfig.dealDetails.id}
    >
      <Banner
        title="Accurate deal values over Microsoft's $25,000 minimum can increase acceptance rates by up to 15%."
        type="info"
      />

      <>
        <SectionTextField name={FieldEnum.name} />
        <SelectPartnerLocation />
        <SectionNumberField name={FieldEnum.dealValue} />
        <SectionTextField name={FieldEnum.currency} />
        <SectionDateField name={FieldEnum.closingDateTime} />
        <SectionTextField disabled={!!params?.crmId} name={FieldEnum.crmId} />
        <SectionTextField name={FieldEnum.campaignId} />
        <Subsection
          dataId="customer-objective-subsection"
          title="Customer objective"
          helpText="Select the solution area and play most closely aligned to your customer’s objectives, and describe your customer’s need to help Microsoft route your referral to an appropriate Microsoft Sales team member."
        >
          <SolutionAreasFields />
          <SectionTextAreaField name={FieldEnum.notes} />
          <SectionRadioGroupField name={FieldEnum.customerMarketplaceIntent} />
        </Subsection>
      </>
    </FormSectionCard>
  );
};

export default DealDetailsFormSection;
